import {version} from '../../../package.json';

export function getAppVersion(): string {
  return version;
}
